function soodoxSearchQuery(value) {
 let term = value.trim();
 const rules = [["sun cream", "sunscreen"], ["suncream", "sunscreen"], ["sun screen", "sunscreen"], ["suncreen", "sunscreen"], ["hair growth", "hairgro"], ["hair grow", "hairgro"], ["hair gro", "hairgro"], ["roll-on", "rollon"], ["roll on", "rollon"], ["sanitizer", "sanitiser"], ["sanitizers", "sanitisers"], ["children", "child"], ["kids", "child"], ["kid ", "child "], ["underwear", "undies"], ["50 g", "50g"], ["100 g", "100g"]];
 for (const [from, to] of rules) term = term.replace(new RegExp(from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), to);
 return term.replace(/\s+/g, ' ').trim();
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.modal = this.closest('.search-modal');
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.querySelector('form.search').addEventListener('submit', this.onFormSubmit.bind(this));
    // :not(.voice-search__button) — the optional mic button is also
    // type="button" and can precede the close button in the field; binding
    // close() to it would dismiss the results/modal on every mic tap.
    this.querySelector('button[type="button"]:not(.voice-search__button)').addEventListener('click', this.close.bind(this));
    this.querySelector('button[type="reset"]').addEventListener('click', this.clear.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

  }

  getQuery() {
    return soodoxSearchQuery(this.input.value);
  }

  onChange() {
    this.dismissedTerm = null;
    this.abortController?.abort();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.predictiveSearchResults.replaceChildren();
      this.removeAttribute('results');
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.clear();
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }
  
  onFormSubmit(event) {
    if (!this.getQuery().length) { event.preventDefault(); return; }
    this.input.value = this.getQuery();
  }

  onFocus() {
    document.body.classList.add('predictive-search--focus');
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  } 

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length && event.target === this.input) {
      this.clear(event);
      this.close(true);
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.dismissedTerm = this.getQuery();
      this.abortController?.abort();
      event.preventDefault();
      this.close();
      this.input.focus();
      this.close();
      return;
    }
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
      this.switchOption(event.key === 'ArrowUp' ? 'up' : 'down');
    } else if (event.key === 'Enter' && this.querySelector('[aria-selected="true"]')) {
      event.preventDefault();
      this.selectOption();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
     
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      /*
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      */
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.hasAttribute('open')) return;
    const options = Array.from(this.querySelectorAll('li[role="option"], .predictive-search__search-for-button')).filter(option => option.getClientRects().length && option.querySelector('a, button'));
    if (!options.length) return;
    const current = options.findIndex(option => option.getAttribute('aria-selected') === 'true');
    const step = direction === 'up' ? -1 : 1;
    const next = current < 0 ? (step > 0 ? 0 : options.length - 1) : (current + step + options.length) % options.length;
    options.forEach(option => {
      option.setAttribute('aria-selected', 'false');
      option.querySelector('a, button').setAttribute('tabindex', '-1');
    });
    const active = options[next];
    active.setAttribute('aria-selected', 'true');
    active.querySelector('a, button').setAttribute('tabindex', '0');
    active.querySelector('a, button').focus();
    this.setLiveRegionText(active.textContent);
    this.input.setAttribute('aria-activedescendant', active.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  // The Predictive Search API does not support every storefront language
  // (e.g. Hebrew) — without a guard, every keystroke would flash the
  // loading spinner, fire a doomed 422 request and log an uncaught error.
  // The search form itself keeps working (/search supports all languages).
  //
  // Primary check: Shopify stamps every storefront page with a
  // #shopify-features JSON whose predictiveSearch flag is false for
  // unsupported locales — proactive, so not even the first request fires.
  // Fallback: a 422 response marks the session as unsupported anyway.
  searchUnsupported() {
    if (PredictiveSearch.unsupported === undefined) {
      try {
        const features = JSON.parse(document.getElementById('shopify-features')?.textContent || '{}');
        PredictiveSearch.unsupported = features.predictiveSearch === false;
      } catch (e) {
        PredictiveSearch.unsupported = false;
      }
    }
    if (PredictiveSearch.unsupported) return true;

    try {
      return sessionStorage.getItem('predictive-search-unsupported') === '1';
    } catch (e) {
      return false;
    }
  }

  markSearchUnsupported() {
    PredictiveSearch.unsupported = true;
    try {
      sessionStorage.setItem('predictive-search-unsupported', '1');
    } catch (e) {
      // Storage unavailable (privacy mode) — the in-memory flag still
      // covers this page view.
    }
  }

  getSearchResults(searchTerm) {
    if (this.searchUnsupported()) return;

    const queryKey = searchTerm.toLowerCase();
    const perPage = 10;
    this.setLiveRegionLoadingState();
    this.abortController?.abort();
    this.abortController = new AbortController();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      if (this.modal) this.modal.classList.add('searching');
      return;
    }

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=${perPage}&${encodeURIComponent('resources[limit_scope]')}=each&resources%5Btype%5D=product&section_id=predictive-search`, {signal: this.abortController.signal})
      .then((response) => {
        if (!response.ok) {
          this.close();

          if (response.status === 417) {
            this.markSearchUnsupported();
            console.warn('[predictive-search] Disabled for this session: the storefront language is not supported by the Predictive Search API.');
            return null;
          }

          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        if (text === null || this.getQuery() !== searchTerm || this.dismissedTerm === searchTerm || !this.contains(document.activeElement)) return;
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        /*
        this.cachedResults[queryKey] = resultsMarkup;
        */
        this.renderSearchResults(resultsMarkup);
        
        if (this.modal) this.modal.classList.add('searching');
      })
      .catch((error) => {
        if (error?.name === 'AbortError' || error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        
        this.close();
        console.warn('[predictive-search] Suggestions unavailable; the search form remains available.');
      }); 
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    const prefix = this.input.id + '-';
    this.predictiveSearchResults.querySelectorAll('[id]').forEach(element => { element.id = prefix + element.id; });
    const listbox = this.predictiveSearchResults.querySelector('[role="listbox"]');
    if (listbox) {
      this.input.setAttribute('aria-controls', listbox.id);
      this.input.setAttribute('aria-owns', listbox.id);
    }
    this.setAttribute('results', true);  

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() { 
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]')?.textContent || '');
  }
  
  getResultsMaxHeight() {
    this.resultsMaxHeight = Math.max(160, (window.visualViewport?.height || window.innerHeight) - this.input.getBoundingClientRect().bottom - 24);
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    document.body.classList.add('predictive-search--focus');
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    document.body.classList.remove('predictive-search--focus');
  }

  clear(event) {
    event?.preventDefault();
    
    this.input.value = '';
    this.removeAttribute('open');
    this.removeAttribute('results');
    this.input.focus();

    if (this.modal) this.modal.classList.remove('searching');
  }
}

customElements.define('predictive-search', PredictiveSearch);
